import { Component, Inject, OnInit } from '@angular/core';
import { MoveItemDialogComponent } from '../move-item-dialog/move-item-dialog/move-item-dialog.component';
import { PlatformQueryService } from '@core/services/platform-query.service';
import { SnackBarService } from '@core/services/snack-bar.service';
import { DialogModel } from '@shared/models/dialog.model';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IDialogView } from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import { IconViewModel, IconViewResponse, PermissionTypes } from '@features/file-manager/models/file-manager.model';
import { take } from 'rxjs';
import { PlatformQuery } from '@shared/models/platform-query/platform-query';
import { FuseSplashScreenService } from '@barebone-fuse/@fuse/services/splash-screen.service';

@Component({
    standalone: false,
    selector: 'app-file-select-from-drive-dialog',
  templateUrl: './file-select-from-drive-dialog.component.html',
  styleUrl: './file-select-from-drive-dialog.component.scss'
})
export class FileSelectFromDriveDialogComponent implements OnInit, IDialogView {
  queryName: string;
  pageSize = 50;
  isClientDrive = true;
  data: DialogModel;
  pageNo = 0;
  pageCount = 1;
  infiniteScrollDisabled = false;
  sourceFileIds: string[];
  iconViewResponse: IconViewResponse;
  copy = false;
  parentId: string;
  parentName: string;
  selectedItem: IconViewModel;
  canMove = false;
  canMoveBySelect = false;
  selectFile = 'Select';
  validFileExtensions = []; // empty means all


  constructor(private fuseSplashScreenService: FuseSplashScreenService,
              private platformQueryService: PlatformQueryService,
              protected snackBarService: SnackBarService,
              @Inject(MAT_DIALOG_DATA) public dialogInfo: DialogModel) {
  }

  ngOnInit(): void {
    this.parentId = this.data.input.data.parentId;
    this.parentName = this.data.input.data.parentName;
    this.isClientDrive = this.data.input.data.isClientDrive;
    this.sourceFileIds = this.data.input.data.sourceFiles;
    if(this.data.input.data.validFileExtensions){
      this.validFileExtensions = this.data.input.data.validFileExtensions;
    }
    this.getItemList(this.parentId, this.pageNo);
    this.dialogInfo.okCaption = this.selectFile;
    this.dialogInfo.isDisabledOkButton = true;
  }

  getItemList(parentId: string, pageNo: number, parentName?: string) {
    const query = new PlatformQuery();
    query.name = 'IconViewQuery';
    if (this.queryName) {
      query.name = this.queryName;
    }
    query.api = 'FileStoreApi';
    query.isCamelCase = true;
    query.fieldValues['ParentId'] = parentId;
    query.fieldValues['IsClientDrive'] = this.isClientDrive;
    query.fieldValues['PageSize'] = this.pageSize;
    query.fieldValues['PageNo'] = pageNo;
    query.fieldValues['FileExtensionTypes'] = [];
    query.fieldValues['HideFiles'] = this.data.input.data.hideFiles;
    query.fieldValues['IconType'] = 'medium';

    this.fuseSplashScreenService.show();
    this.platformQueryService.executeQuery(query).pipe(take(1)).subscribe(response => {
      const iconViewResponse = response.fieldValues['IconViewResponse'];
      iconViewResponse.items = iconViewResponse.items.filter(o => {
        if (((o.type === 'SharedDrive' || o.type === 'SharedDrives' || o.type === 'PersonalDrive' || !this.sourceFileIds.includes(o.itemId))) && this.isValidFile(o)) {
          return o;
        }
      });
      if (!parentName) {
        this.parentName = iconViewResponse.parentName;
      } else {
        this.parentName = parentName;
      }
      if (this.pageNo === 0) {
        this.iconViewResponse = iconViewResponse;
        this.pageCount = iconViewResponse.pageCount;
      } else {
        this.iconViewResponse.items = [...this.iconViewResponse.items, ...iconViewResponse.items];
      }
      this.fuseSplashScreenService.hide();
    });
    this.parentId = parentId;
    this.selectedItem = null;
  }

  isValidFile(file: any) : boolean{
    if(file.type != 'File'){
      return false;
    }
    let extension = file.name.split('.').pop();
    if(this.validFileExtensions.length > 0){
      if(this.validFileExtensions.find(ext=> ext == extension)){
        return true
      } else {
        false
      }
    } else {
      return true;
    }
  }

  onOkClicked(): boolean {
  
    if(this.selectItem){
      this.data.input.selectedFile = this.selectedItem;
      console.log(this.data);
      return true;
    } else {
      this.snackBarService.showError('Please select a file');
      return false;
    }  
  }

  handleAction(type: string, item?: IconViewModel) {
    switch (type) {
      case 'OnBack':
        this.onBack();
        break;
      case 'GoToItem':
        this.goToItem(item);
        break;
      case 'SelectItem':
        this.selectItem(item);
        break;
      default:
        break;
    }
    this.checkValidity();
  }

  goToItem(item: IconViewModel) {
    if(item.type == 'File'){
      return;
    }
    if (this.parentId === '') {
      this.pageNo = 0;
      this.pageCount = 0;
      if (item.type === 'PersonalDrive') {
        this.getItemList(item.itemId, this.pageNo);
      } else {
        this.getItemList('Team Drives', this.pageNo);
      }
      this.canMove = false;
    } else {
      this.pageNo = 0;
      this.pageCount = 0;
      item.type === 'SharedDrive' ? this.canMove = false : this.canMove = true;
      this.getItemList(item.itemId, this.pageNo);
    }
    this.dialogInfo.okCaption = this.selectFile;
  }

  onBack() {
    this.isClientDrive = true;
    this.pageNo = 0;
    this.dialogInfo.okCaption = this.selectFile;
    if (this.iconViewResponse.parentType === 'Folder') {
      this.canMove = this.iconViewResponse.parentId !== this.iconViewResponse.driveId;
      this.canMove = true;
      this.getItemList(this.iconViewResponse.parentId, this.pageNo);
      return;
    }
    if (this.iconViewResponse.parentId === null) {
      if (this.iconViewResponse.driveType === 'SharedDrives') {
        this.canMove = false;
        this.getItemList('', this.pageNo, 'Orbitax Drive');
      }
      return;
    }
    if (this.iconViewResponse.parentId && this.iconViewResponse.parentId === this.iconViewResponse.driveId) {
      if (this.iconViewResponse.isDefaultDrive) {
        if (this.iconViewResponse.parentType === 'SharedDrives') {
          this.parentName = 'Team Drives';
          this.canMove = false;
          this.getItemList('Team Drives', this.pageNo);
        }
        if (this.iconViewResponse.parentType === 'SharedDrive') {
          this.canMove = false;
          this.getItemList(this.iconViewResponse.parentId, this.pageNo);
        }
      } else if (!this.iconViewResponse.isDefaultDrive) {
        if (this.iconViewResponse.parentType === 'PersonalDrive') {
          this.canMove = false;
          this.getItemList(this.iconViewResponse.parentId, this.pageNo);
        } else {
          this.canMove = false;
          this.getItemList('', this.pageNo, 'Orbitax Drive');
        }
      } else {
        this.canMove = false;
        this.getItemList('', this.pageNo, 'Orbitax Drive');
      }
      return;
    }
  }

  selectItem(item: IconViewModel) {
    if (this.selectedItem === item) {
      this.selectedItem = null;
      this.canMoveBySelect = false;
      this.dialogInfo.okCaption = this.selectFile;
    } else {
      this.dialogInfo.okCaption = this.selectFile;
      this.canMoveBySelect = item.canCopyOrMoveHere;
      this.selectedItem = item;
    }
  }

  onScroll() {
    if (this.pageNo + 1 >= this.pageCount) {
      this.infiniteScrollDisabled = true;
      return;
    }
    this.getItemList(this.parentId, ++this.pageNo);
  }

  private checkValidity() : void {
    const itemParentId = this.data.input.data.parentId;
    if (this.selectedItem) {
      if(this.selectedItem.type == 'File'){
        let extension = this.selectedItem.name.split('.').pop();
        if(this.validFileExtensions.length > 0){
          if(this.validFileExtensions.find(ext=> ext == extension)){
            this.dialogInfo.isDisabledOkButton = false;
          }
          else{
            this.dialogInfo.isDisabledOkButton = true;
          }
        }
        else{
          this.dialogInfo.isDisabledOkButton = false;
        }
        return;
      }
    }
    this.dialogInfo.isDisabledOkButton = true;
    return;
  }
}
